// Dependent drop-down questions: one main drop-down whose selection decides the options of a sub drop-down.
// Question `answers` holds { sub_question_no: '5.1', sub_question: 'District', options: [{ option: 'Kerala', sub_options: ['Ernakulam', ...] }] }
// and the applicant's answer is saved as one readable string, "Kerala / Ernakulam".

export const DEPENDENT_SEPARATOR = " / ";

export function dependentOptions(question) {
  return question?.answers?.options || [];
}

export function subOptionsFor(question, main) {
  const option = dependentOptions(question).find((o) => o.option === main);
  return option ? option.sub_options || [] : [];
}

// null until the answer is complete, so a mandatory question stays unanswered with only the main option picked
export function joinDependentAnswer(question, main, sub) {
  if (!main) return null;
  if (!subOptionsFor(question, main).length) return main;
  return sub ? main + DEPENDENT_SEPARATOR + sub : null;
}

// matched against the known main options instead of splitting, so options containing "/" still work
export function splitDependentAnswer(question, answer) {
  if (!answer) return { main: null, sub: null };
  const matches = dependentOptions(question)
    .map((o) => o.option)
    .filter((main) => answer === main || answer.startsWith(main + DEPENDENT_SEPARATOR))
    .sort((a, b) => b.length - a.length);
  if (!matches.length) return { main: null, sub: null };
  const main = matches[0];
  const sub = answer === main ? null : answer.slice(main.length + DEPENDENT_SEPARATOR.length);
  return { main, sub };
}
